
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import routes from 'lib/routes';
import { cleartBooklistCriteriaCache } from 'lib/bookListCriteriaCache';

const RoutChangeListener = withRouter(({ history, children }) => { // See: https://stackoverflow.com/questions/45373742/detect-route-change-with-react-router/45373907
    useEffect(() => {
        const unlisten = history.listen((loc) => {
            const pathName = loc.pathname;
            // Clear booklist criteria state cache
            if ((pathName.indexOf(routes.bookList) === -1 && pathName.indexOf(routes.editBook) === -1) || pathName === routes.addBook) {
                //console.log('clear!' + (new Date()).getTime(), pathName, pathName.indexOf(routes.bookList));
                cleartBooklistCriteriaCache();
            }
        });
        return () => unlisten();
    });
    return children;
});

export default RoutChangeListener;